module.exports = __webpack_public_path__ + "img/plan.4b5e053f.svg";